import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CourseLessonService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CourseLesson');
	}

    bulkEdit(): Observable<ePM.Logic.CourseLesson[]> {
		return this.myBaseService.loadAll(this.url + '/BulkEdit');
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.CourseLesson> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.CourseLesson> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.CourseLesson>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<ePM.Logic.CourseLesson[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search');
	}
}
				